<template>
    <tr>
        <td>
            {{item.codigo}}
        </td>

        <td>
            {{item.nomeCliente}}
        </td>

        <td>
            {{item.nomeCampanha}}
        </td>

        <td>
            {{item.nomeAparelho}}
        </td>

        <td>
            {{$date.format(new Date(item.data))}}
        </td>

    </tr>
</template>

<script>
    import tableItem from '@mixins/table-item'
    export default {
        components: {
        },

        data() {
            return {
                entity: 'promocionalcode'
            }
        },
        methods: {
        },

        mixins: [tableItem]
    }
</script>

<style lang="scss" scoped>
    @import "~@variables";

    .edit {

        .mdi {
            font-size: 18px;

            &:not(:last-child) {
                margin-right: 6px;
            }
        }
    }
</style>
